export const environment = {
  production: true,
  name: 'prod',
  cmsResourcesURL: '/ignite-your-tv/assets/i18n/',
  apiBaseUrl: '/cloud/buyflow/coam',
  apimSubscriptionKey: {
    qa: 'sOHkqMNxSKIBbnh8nzPrWxCN',
    prod: 'tVsaR1s4NJHDzVhSxY6ejOtS'
  },
  subType: ['IPTV'],
  microServices: {
    baseUrl: 'https://mservices.rogers.com',
  },
};
